import { render, staticRenderFns } from "./TextComponent.vue?vue&type=template&id=2c76d08e&scoped=true&"
import script from "./TextComponent.vue?vue&type=script&lang=js&"
export * from "./TextComponent.vue?vue&type=script&lang=js&"
import style0 from "./TextComponent.vue?vue&type=style&index=0&id=2c76d08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76d08e",
  null
  
)

export default component.exports